import {h} from 'preact';
import {createPortal} from 'preact/compat';
import {useEffect, useState} from "preact/hooks";
import { CloseOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import store from '../store';
import * as actions from '../actions';

const steps = {
  one: 'one',
  two: 'two',
  three: 'three',
  four: 'four',
  five: 'five',
}

export default function POSTourModal({isSquare, isTreez, isPopmenu, open, onClose}) {
  const [step, setStep] = useState(steps.one);
  const [videoLinks, setVideoLinks] = useState([]);
  const [numSteps, setNumSteps] = useState(5);

  useEffect(() => {
    if (isPopmenu) {
      setNumSteps(4);
    } else {
      setNumSteps(5);
    }
  })

  useEffect(() => {
    if (isSquare) {
      setVideoLinks([
        'https://timber.mhmcdn.com/site/timber/POSTourSquare1.mp4',
        'https://timber.mhmcdn.com/site/timber/POSTourSquare2.mp4',
        'https://timber.mhmcdn.com/site/timber/POSTourSquare3.mp4',
        'https://timber.mhmcdn.com/site/timber/POSTourSquare4.mp4'
      ])
    } else if (isTreez) {
      setVideoLinks([
        'https://timber.mhmcdn.com/site/timber/POSTourTreez1.mp4',
        'https://timber.mhmcdn.com/site/timber/POSTourTreez2.mp4',
        'https://timber.mhmcdn.com/site/timber/POSTourTreez3.mp4',
        'https://timber.mhmcdn.com/site/timber/POSTourTreez4.mp4'
      ])
    } else if (isPopmenu) {
      setVideoLinks([
        'https://timber.mhmcdn.com/site/timber/POSTourPopmenu1.webp',
        'https://timber.mhmcdn.com/site/timber/POSTourPopmenu2.webp',
        'https://timber.mhmcdn.com/site/timber/POSTourPopmenu3.webp'
      ])
    } else {
      setVideoLinks([
        'https://timber.mhmcdn.com/site/timber/POSTourToast1.mp4',
        'https://timber.mhmcdn.com/site/timber/POSTourToast2.mp4',
        'https://timber.mhmcdn.com/site/timber/POSTourToast3.mp4',
        'https://timber.mhmcdn.com/site/timber/POSTourToast4.mp4'
      ])
    }
  }, [isSquare, isTreez, isPopmenu]);

  function onModalClose() {
    setStep(steps.one);
    store.dispatch(actions.setIsDataLibraryModal(true));
    onClose();
  }

  function openChat() {
    Intercom('showNewMessage', "I'd like to import my menu data!")
  }

  return !open ? null : createPortal(<div>
    <div className="modal-back" onClick={onModalClose} />
    <div className="modal tour-modal">
      <div class="close-btn" onClick={onModalClose}><CloseOutlined/></div>
      {step === steps.one &&
      <div class="content">
        {!isPopmenu && <video playsInline muted autoPlay loop src={videoLinks[0]} />}
        {isPopmenu && <img src={videoLinks[0]} />}
        <div class="step-text">
          <div class="step-title">POS data appears in My Menu Groups</div>
          <div class="navigation nav-pos">
            <div class="step-num">1 / {numSteps}</div>
            <div onClick={() => setStep(steps.two)} class="step-next"><RightOutlined/></div>
          </div>
        </div>
      </div>}

      {step === steps.two &&
      <div class="content">
        {!isPopmenu &&<video playsInline muted autoPlay loop src={videoLinks[1]}/>}
        {isPopmenu && <img src={videoLinks[1]} />}
        <div class="step-text">
          <div class="step-title">Easily replace old menu sections with linked POS data</div>
          <div class="navigation nav-pos">
            <div onClick={() => setStep(steps.one)} class="step-back"><LeftOutlined/></div>
            <div class="step-num">2 / {numSteps}</div>
            <div onClick={() => setStep(isPopmenu ? steps.four : steps.three)} class="step-next"><RightOutlined/></div>
          </div>
        </div>
      </div>}

      {!isPopmenu && step === steps.three &&
      <div class="content">
        <video playsInline muted autoPlay loop src={videoLinks[2]}/>
        <div class="step-text">
          <div class="step-title">You're free to make edits and your data stays linked</div>
          <div class="navigation nav-pos">
            <div onClick={() => setStep(steps.two)} class="step-back"><LeftOutlined/></div>
            <div class="step-num">3 / {numSteps}</div>
            <div onClick={() => setStep(steps.four)} class="step-next"><RightOutlined/></div>
          </div>
        </div>
      </div>}

      {step === steps.four &&
      <div class="content">
        {!isPopmenu && <video playsInline muted autoPlay loop src={videoLinks[3]}/>}
        {isPopmenu && <img src={videoLinks[2]} />}
        <div class="step-text">
          <div class="step-title">Later, review, approve, and sync new POS updates in bulk from Design Updater</div>
          <div class="navigation nav-pos">
            <div onClick={() => setStep(isPopmenu ? steps.two : steps.three)} class="step-back"><LeftOutlined/></div>
            <div class="step-num">{numSteps - 1} / {numSteps}</div>
            <div onClick={() => setStep(steps.five)} class="step-next"><RightOutlined/></div>
          </div>
        </div>
      </div>}

      {step === steps.five &&
      <div class="content last-step-pos">
        <h2>Try our menu setup services</h2>
        <div class="step-subheader">Have our specialists onboard your POS data into menu designs</div>
        <img src="https://timber.mhmcdn.com/site/timber/POSTour5.webp"/>
        <div class="step-title">Fast&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;&nbsp;&nbsp;Affordable&nbsp;&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;&nbsp;&nbsp;Maintain Brand</div>
        <div className="btn primary medium" onClick={() => openChat()}>
          <span>Chat now</span>
        </div>
        <div class="step-text">
          <div class="navigation nav-pos">
            <div onClick={() => setStep(steps.four)} class="step-back"><LeftOutlined/></div>
            <div class="step-num">{numSteps} / {numSteps}</div>
          </div>
        </div>
      </div>}
    </div>
  </div>, document.getElementById('modals'));
}
